import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PrimaryButton from '@/common/PrimaryButton';
import { useNavigate } from '@tanstack/react-router';

const css = {
  mainBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '100vh',
    justifyContent: 'center',
  },
  text: { fontFamily: 'BrandonGrotesque', fontWeight: '800', fontSize: '4rem', mb: 1 },
  btnBox: {
    width: '70%',
    mt: 3,
  },
};

/**
 * Return a not fount message and a btn to return to the main page
 * @returns {JSX.Element}
 */

const NotFound = () => {
  const navigate = useNavigate();
  const handleBackHomeClick = () => navigate({ to: '/' });

  return (
    <Box sx={css.mainBox}>
      <Typography variant="h1" sx={css.text}>
        404
      </Typography>
      <Typography variant="h2">Página no encontrada</Typography>
      {/* Back button */}
      <Box sx={css.btnBox}>
        <PrimaryButton text={'Volver al inicio'} onClick={handleBackHomeClick} />
      </Box>
    </Box>
  );
};

export default NotFound;
